import React from 'react';
import { Badge, BadgeProps, badgeClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ElevatedBadge = styled(({ ...props }: BadgeProps) => (
  <Badge {...props} />
))(({ theme }) => ({
  '.MuiBadge-badge': {
    border: `1px solid white`,
    boxShadow: theme.shadows[1],
  },
}));
